import { useEffect, useRef } from "react";
import useOnScreen from "./useOnScreen";


const useInfiniteScroll = ({querySelector, fetchCondition, fetchCb}: any) => {
    const paginationDiv = useRef<HTMLDivElement>();
    const isMounted = useRef<boolean>(false);
    const isVisible = useOnScreen(paginationDiv, document.querySelector(querySelector))

    useEffect(() => {
        isMounted.current = true;

        return () => {
            isMounted.current = false;
            paginationDiv.current = undefined;
        }
    }, [])

    useEffect(() => {
        if (isVisible && fetchCondition) {
            isMounted.current && fetchCb();
        }
    }, [isVisible])


    return  { paginationDiv }

} 

export default useInfiniteScroll